module.exports = __webpack_public_path__ + "static/img/salesheet-uc-mc.1a07055.png";